import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ArrowRight } from "lucide-react";
import { Link } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Sidebar } from './Sidebar';
import { useNavigate } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import 'aos/dist/aos.css';
import AOS from 'aos';
import BASE_URL from './apibaseurl/ApiBaseUrl';

interface Blog {
  id: string;
  slug: string;
  title: string;
  picture: string;
}


const testimonials = [
  {
    name: "Ahmet G.",
    role: "Event Manager",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    text: "It is the best tool for leads collection. During my events I share QR Code on the screen and attendees scan it and fill in the answers, it enables me to reach them out after the event.",
    rating: 5,
  },
  {
    name: "Allen W.",
    role: "Event Organizer",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
    text: "Very easy to register names and manual payments without the need of the complex system, I have my team working on it smoothly.",
    rating: 5,
  },
  {
    name: "Deniz S.",
    role: "Exhibitor",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
    text: "With LiveQR, I was able to know who was interested and drop by my booth during the exhibition. I use it every time we have a stand.",
    rating: 5,
  },
  {
    name: "Maria L.",
    role: "Marketing Director",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    text: "LiveQR helped us engage with our audience at trade shows like never before. We collected high-quality leads in minutes!",
    rating: 5,
  },
  {
    name: "John T.",
    role: "Startup Founder",
    image: "https://randomuser.me/api/portraits/men/55.jpg",
    text: "This tool simplified our lead capture process at pitch events. No more printed forms or missed contacts!",
    rating: 4,
  },
  {
    name: "Fatima R.",
    role: "Conference Host",
    image: "https://randomuser.me/api/portraits/women/66.jpg",
    text: "Managing attendee information used to be a hassle—now it’s seamless thanks to LiveQR’s smart QR registration.",
    rating: 5,
  },
];

export function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800, // Animation duration in milliseconds
      once: true, // Animations occur only once
      offset: 100, // Trigger animations 100px before element enters viewport
    });
  }, []);

  const handleClick = (type: "login" | "signup") => {
    if (type === "login") {
      navigate("/login");
    } else {
      navigate("/signup");
    }
  };

  const [blogData, setBlogData] = useState<Blog[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const hasFetched = React.useRef(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userData, setUserData] = useState<UserData | null>(null);
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await fetch(`${BASE_URL}/splashScreen`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.status === 1 && Array.isArray(data.data?.blogs)) {
          setBlogData(data.data.blogs);
        } else {
          setError("No blogs available");
          setBlogData([]);
        }

      } catch (err) {
        setError("Failed to fetch blogs.");
        setBlogData([]);
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    const loadUserData = () => {
      const storedUser = localStorage.getItem('userData');
      if (storedUser) {
        try {
          setUserData(JSON.parse(storedUser));
        } catch {
          setUserData(null);
        }
      } else {
        setUserData(null);
      }
    };

    loadUserData();

    const syncLogout = (event: StorageEvent) => {
      if (event.key === 'logout' || (event.key === 'userData' && event.newValue === null)) {
        setUserData(null);
      }
    };

    window.addEventListener('storage', syncLogout);

    return () => {
      window.removeEventListener('storage', syncLogout);
    };
  }, []);

  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem('userData');
    localStorage.setItem('logout', Date.now().toString());
    setUserData(null);
    setMenuOpen(false);
    navigate('/login');
  };

  if (error) {
    return <div className="text-center py-20 text-red-500">{error}</div>;
  }


  return (<>
    {/* section 1  */}
    <div className="flex flex-col bg-gray-100">
      {/* Mobile Top Section: Carousel */}
      <div className="block md:hidden">
        <Outlet context={{ section: "carousel" }} />
      </div>
      {/* Main Content and Sidebar */}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1  overflow-y-auto">
          <Outlet context={{ section: "main" }} />
        </main>
      </div>
      <div className="bg-[#156E77] text-white py-4 px-3 sm:px-6 md:px-10">
        <div className="max-w-7xl mx-auto flex flex-nowrap items-center justify-between gap-2">

          <p className=" helvetica-neue flex-1 text-left tracking-wide font-normal !text-xs  lg:!text-xl text-wrap truncate pr-2">
            Protect your QR Codes and get more statistics by having an account!
          </p>

          {/* <div className="flex flex-nowrap gap-2 sm:gap-4 items-center font-thin">

                        <button
                            type="button"
                            onClick={() => handleClick("login")}
                            className="uppercase text-white text-[10px] sm:text-xs md:text-lg bg-[#156E77] px-2 py-1 sm:px-4 sm:py-2 text-center whitespace-nowrap transition transform scale-y-125"
                        >
                            LOG IN
                        </button>

                        <button
                            type="button"
                            onClick={() => handleClick("signup")}
                            className="uppercase flex items-center justify-center gap-1 transition transform scale-y-125 text-xs lg:text-[18px] font-normal lg:px-4 lg:py-3 px-2 py-2  
        bg-white text-black  whitespace-nowrap btn-hover-white"
                        >

                            <span>SIGN UP</span>
                            <span className="icon-arrow-right">
                                <ArrowRight className="w-4 h-4" />

                            </span>
                        </button>
                    </div> */}


          <div className="flex gap-4 items-center justify-center">
            {(userData?.user_id || userData?.admin_id) ? (
              <>
                <button
                  className="uppercase flex items-center justify-center gap-1 transition transform scale-y-125 text-xs lg:text-[18px] font-normal lg:px-4 lg:py-3 px-2 py-2  
        bg-white text-black  whitespace-nowrap btn-hover-white"
                  onClick={() => {
                    setMenuOpen(false);
                    if (userData?.redirect_url) {
                      window.location.href = userData.redirect_url;
                    } else {
                      navigate('/dashboard');
                    }
                  }}
                >
                  <span>Go to Dashboard</span>

                  <span className="icon-arrow-right">
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </span>
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  onClick={() => handleClick("login")}
                  className="uppercase text-white text-[10px] sm:text-xs md:text-lg bg-[#156E77] px-2 py-1 sm:px-4 sm:py-2 text-center whitespace-nowrap transition transform scale-y-125"
                >
                  LOG IN
                </button>
                <button
                  className="uppercase flex items-center justify-center gap-1 transition transform scale-y-125 text-xs lg:text-[18px] font-normal lg:px-4 lg:py-3 px-2 py-2  
        bg-white text-black  whitespace-nowrap btn-hover-white"
                  onClick={() => {
                    setMenuOpen(false);
                    navigate('/signup');
                  }}
                >
                  <span>    Sign Up</span>
                </button>
              </>
            )}
          </div>

        </div>
      </div>

    </div>

    {/* section 2  */}
    <div className="w-full" data-aos="fade-up" data-aos-delay="100">
      <div
        className="bg-cover bg-center text-white py-20 bg-[#234042]"
        style={{ backgroundImage: "url('/images/Clip.png')" }}
      >
        <div className="text-center mx-auto px-8 lg:px-0 max-w-7xl">
          <h1 className="Bebas-neue text-[38px] sm:text-3xl md:text-[75px] uppercase text-left mb-[39px] leading-tight">
            Your Registration System in a QR Code
          </h1>
          <div className="flex flex-col sm:flex-row lg:items-center items-baseline justify-between gap-4">
            <p className="helvetica-neue lg:text-[30px] text-[#FFFFFF] font-extralight leading-[1.5] sm:text-lg mb-0 text-left sm:text-left">
              Check out our options and features included
            </p>
            <button
              className="oswald uppercase flex items-center gap-1 sm:gap-2 shadow-none rounded-none no-underline tracking-tight bg-transparent text-black bg-white transition transform scale-y-125 text-xs lg:text-[20px] font-normal lg:px-4 lg:py-3 px-2 py-2 btn-hover-white"
            >
              <span>Get Started Now</span>
              <span className="icon-arrow-right">
                <ArrowRight className="w-4 h-4 ml-1" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white py-20 px-8 mx-auto" data-aos="fade-up" data-aos-delay="200">
        <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-7">
          {[
            { img: "attraction 2.png", alt: "Lead", title: "Lead", desc: "Lead Attraction Tool" },
            { img: "attraction 3.png", alt: "Custom", title: "Custom", desc: "Customized Outcomes" },
            { img: "attraction 4.png", alt: "Innovative", title: "Innovative", desc: "Innovative Platform" },
            { img: "attraction 1.png", alt: "Friendly", title: "Friendly", desc: "User Friendly" }
          ].map((item, index) => (
            <div
              key={index}
              className="relative bg-[#156E77] text-white flex flex-col justify-start items-start p-6 rounded-lg overflow-hidden transition-all before:absolute before:h-0 before:w-full before:bg-[#234042] before:duration-500 before:ease-out before:left-0 before:bottom-0 hover:shadow-orange-600 hover:before:h-full"
              data-aos="zoom-in"
              data-aos-delay={`${index * 100}`}
            >
              <LazyLoad height={71} offset={100} once>
                <img src={`/images/${item.img}`} alt={item.alt} className="w-[71px] h-[71px] mb-5 ml-2 relative z-10" />
              </LazyLoad>
              <h3 className="uppercase oswald text-xl font-medium whitespace-nowrap text-left w-full space-x-1 mb-2 relative z-10 transition-colors duration-500">
                {item.title}
              </h3>
              <p className="text-md lg:text-[20px] font-normal mt-2 text-left helvetica-neue relative z-10 transition-colors duration-500">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
        <div className="mt-12" data-aos="fade-up" data-aos-delay="300">
          <div className="max-w-7xl mx-auto flex flex-col items-center justify-between gap-4 md:gap-8 px-2 md:px-6 py-4">
            <h3
              style={{ transform: "scaleY(1.2)" }}
              className="Bebas-neue uppercase text-[#234042] text-3xl lg:text-[75px] leading-[1.2] text-center font-bold mb-4 mt-4 tracking-wide"
            >
              Best Leads Collection Tool for Event Organizers
            </h3>
            <button className="bg-[#F47321] hover:bg-[#e05f12] text-white font-normal uppercase transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2 rounded-none  flex items-center gap-2 mt-2 md:mt-0 whitespace-nowrap btn-hover-effect">
              <span>Create your QR code now</span>
              <span className="icon-arrow-right">
                <ArrowRight className="w-4 h-4" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    {/* section 3  */}
    <div className="bg-[#234042] py-12 px-8 lg:px-0" data-aos="fade-up" data-aos-delay="100">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="bg-white rounded-xl p-[80px] flex justify-center" data-aos="zoom-in" data-aos-delay="200">
          <LazyLoad height={200} offset={100} once>
            <img src="/images/Frame-1.png" alt="QR Code Scan" className="w-full max-w-md h-auto" />
          </LazyLoad>
        </div>
        <div className="text-white text-left sm:text-left mx-auto sm:mx-0" data-aos="fade-left" data-aos-delay="300">
          <h3
            style={{ transform: "scaleY(1.2)" }}
            className="Bebas-neue uppercase text-white text-3xl sm:text-4xl md:text-5xl lg:text-[75px] xl:text-[69px] leading-[1.2] text-left font-bold mb-4 mt-4 tracking-wide"
          >
            For<br /> Exhibitors
          </h3>
          <ul className="list-disc list-inside space-y-2 text-white font-light ml-[30px] tracking-normal">
            <p><li className="lg:text-[1.4rem] text-md">Host your PDF brochure in a QR code</li></p>
            <p><li className="lg:text-[1.4rem] text-md">Host your product images in a QR code</li></p>
            <p><li className="lg:text-[1.4rem] text-md">Collect the leads from real people.</li></p>
            <p><li className="lg:text-[1.4rem] text-md">Create a questionnaire in the QR code</li></p>
            <p><li className="lg:text-[1.4rem] text-md">Download responses in excel</li></p>
          </ul>
        </div>
      </div>
    </div>

    {/* section 4 */}
    <div className="bg-white py-12 px-8 lg:px-0" data-aos="fade-up" data-aos-delay="100">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:grid lg:grid-cols-2 gap-10 items-center">
        <div className="text-left lg:text-left" data-aos="fade-right" data-aos-delay="200">
          <h3
            style={{ transform: "scaleY(1.2)" }}
            className="Bebas-neue uppercase text-[#234042] text-3xl sm:text-4xl md:text-5xl lg:text-[75px] xl:text-[69px] leading-[1.2] text-left font-bold mb-4 mt-4 tracking-wide"
          >
            For<br /> Events Managers
          </h3>
          <p className="lg:text-[1.4rem] text-lg text-[#234042] ml-[60px] mr-[30px] tracking-normal helvetica-neue leading-[35px]">
            Custom-made data that help you generate a QR code that helps you get the list of those who scanned it.
            If your event is a paid one, you can collect money at the door to avoid mistakes of calculations.
          </p>
        </div>
        <div className="flex justify-center p-[80px]" data-aos="zoom-in" data-aos-delay="300">
          <LazyLoad height={200} offset={100} once>
            <img src="/images/11136 1.png" alt="QR for Events Managers" className="w-full max-w-md h-auto" />
          </LazyLoad>
        </div>
      </div>
    </div>

    {/* section 5 */}
    <div className="bg-[#234042] py-12 px-8 lg:px-0" data-aos="fade-up" data-aos-delay="100">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="bg-white rounded-xl p-[80px] flex justify-center" data-aos="zoom-in" data-aos-delay="200">
          <LazyLoad height={200} offset={100} once>
            <img src="/images/Frame.png" alt="QR Code Scan" className="w-full max-w-md h-auto" />
          </LazyLoad>
        </div>
        <div className="text-white text-left sm:text-left mx-auto sm:mx-0" data-aos="fade-left" data-aos-delay="300">
          <h3
            style={{ transform: "scaleY(1.2)" }}
            className="uppercase text-white text-3xl sm:text-4xl md:text-5xl lg:text-[75px] xl:text-[69px] leading-[1.2] text-left font-bold mb-4 mt-4 tracking-wide Bebas-neue"
          >
            Give your<br /> Event an IQ
          </h3>
          <p className="helvetica-neue text-white/90 ml-[80px] leading-[1.5] tracking-wide mb-3">
            By giving your audience different types of questions you can get the answers to develop your business
          </p>
          <ul className="list-disc list-inside space-y-2 text-white text-[20px] sm:text-lg ml-[120px] tracking-normal">
            <p><li>Drag and drop questions</li></p>
            <p><li>Multiple selection options</li></p>
            <p><li>Radio button options</li></p>
            <p><li>Drop-down options</li></p>
          </ul>
        </div>
      </div>
    </div>

    {/* section 6  */}
    <div className="bg-white py-12 px-8 lg:px-0" data-aos="fade-up" data-aos-delay="100">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:grid lg:grid-cols-2 gap-10 items-center">
        <div className="text-left lg:text-left" data-aos="fade-right" data-aos-delay="200">
          <h3
            style={{ transform: "scaleY(1.2)" }}
            className="uppercase text-[#234042] text-3xl sm:text-4xl md:text-5xl lg:text-[75px] xl:text-[69px] leading-[1.2] text-left font-bold mt-4 tracking-wide mb-8 Bebas-neue"
          >
            online <br /> Registration <br /> System
          </h3>
          <p className="text-[20px] sm:text-lg ml-[80px] text-[#234042] tracking-normal helvetica-neue">
            Register your attendees or let them register themselves with a link or a QR code
          </p>
        </div>
        <div className="flex justify-center p-[80px]" data-aos="zoom-in" data-aos-delay="300">
          <LazyLoad height={200} offset={100} once>
            <img src="/images/Frame-2.png" alt="QR for Events Managers" className="w-full max-w-md h-auto" />
          </LazyLoad>
        </div>
      </div>
    </div>

    {/* section 7  */}
    <div className="w-full bg-white pt-10 px-8 lg:px-0" data-aos="fade-up" data-aos-delay="100">
      <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-6">
        {[
          { img: "a1.png", alt: "Data Collection", title: "Data Collection", desc: "Automate data collection and save time and effort." },
          { img: "a5.png", alt: "Security", title: "Security", desc: "Have all event data secured in one place." },
          { img: "a4.png", alt: "Download", title: "Download", desc: "Download your list in an excel format." },
          { img: "a2.png", alt: "Data", title: "Data", desc: "Make better data-driven decisions campaigns." },
          { img: "a5.png", alt: "Contact", title: "Contact", desc: "Enhance customers experience." }
        ].map((item, index) => (
          <div
            key={index}
            className="relative bg-[#156E77] text-white flex flex-col p-6 justify-start items-start rounded-lg overflow-hidden transition-all before:absolute before:h-0 before:w-full before:bg-[#234042] before:duration-500 before:ease-out before:left-0 before:bottom-0 hover:shadow-orange-600 hover:before:h-full"
            data-aos="zoom-in"
            data-aos-delay={`${index * 100}`}
          >
            <LazyLoad height={71} offset={100} once>
              <img src={`/images/${item.img}`} alt={item.alt} className="w-[71px] h-[71px] mb-[25px] ml-2 relative z-10" />
            </LazyLoad>
            <h3 className="oswald uppercase lg:text-lg text-sm font-normal whitespace-nowrap text-left w-full space-x-1 mb-[15px] relative z-10">
              {item.title}
            </h3>
            <p className="text-white/60 text-sm lg:text-md font-light mt-2 text-left helvetica-neue relative z-10">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-12" data-aos="fade-up" data-aos-delay="200">
        <div className="max-w-7xl mx-auto flex flex-col items-start lg:items-center justify-between gap-4 md:gap-8 px-2 md:px-6 py-4">
          <h3
            style={{ transform: "scaleY(1.2)" }}
            className="Bebas-neue uppercase text-[#234042] text-3xl lg:text-[75px] leading-[1.2] text-center font-bold mb-4 mt-4 tracking-wide"
          >
            Connect with customers and audience the right way.
          </h3>
          <button className="bg-[#F47321] hover:bg-[#e05f12] text-white font-normal uppercase transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2 rounded-none  flex items-center gap-2 mt-2 md:mt-0 whitespace-nowrap btn-hover-effect">
            <span>Create your QR code now</span>
            <span className="icon-arrow-right">
              <ArrowRight className="w-4 h-4" />
            </span>
          </button>
        </div>
      </div>
    </div>

    {/* section 8  */}
    <section className="bg-white text-center px-8 lg:px-0 lg:pt-[100px] pt-[100px] " data-aos="fade-up" data-aos-delay="100">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-start md:items-center mb-8 space-y-4 md:space-y-0 md:space-x-20">
        <h2 className="Bebas-neue text-2xl md:text-4xl lg:text-[75px] font-bold text-[#234042] whitespace-nowrap uppercase">
          TESTIMONIALS
        </h2>
        <p className="text-[#234042] text-left text-[16px] flex-1 font-medium helvetica-neue">
          Don’t just take our word for it—see what our customers are saying about their experience with LiveQR. From businesses to individuals, our users share how LiveQR has made a real difference in the way they connect and engage.
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4">
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{ clickable: true, el: '.swiper-pagination-testimonials' }}
          navigation={{
            nextEl: '.swiper-button-next-testimonials',
            prevEl: '.swiper-button-prev-testimonials',
            hiddenClass: 'swiper-button-hidden',
            disabledClass: 'swiper-button-disabled',
          }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="relative"
        >
          {testimonials.map((t, idx) => (
            <SwiperSlide key={idx} className="flex justify-center">
              <div className="helvetica-neue w-full max-w-sm shadow-md  h-full min-h-[360px] bg-white p-6 flex flex-col justify-between relative overflow-hidden transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-xl group" data-aos="zoom-in" data-aos-delay={`${idx * 100}`}>

                <span className="absolute left-0 top-0 h-0 w-0 border-t-2 border-transparent transition-all duration-500 group-hover:w-full" style={{ borderImage: 'linear-gradient(to right, #234042, #156E77) 1' }}></span>
                <span className="absolute right-0 top-0 h-0 w-0 border-r-2 border-transparent transition-all duration-500 group-hover:h-full" style={{ borderImage: 'linear-gradient(to bottom, #234042, #156E77) 1' }}></span>
                <span className="absolute bottom-0 right-0 h-0 w-0 border-b-2 border-transparent transition-all duration-500 group-hover:w-full" style={{ borderImage: 'linear-gradient(to left, #234042, #156E77) 1' }}></span>
                <span className="absolute bottom-0 left-0 h-0 w-0 border-l-2 border-transparent transition-all duration-500 group-hover:h-full" style={{ borderImage: 'linear-gradient(to top, #234042, #156E77) 1' }}></span>

                <div className="flex-1 relative z-10">
                  <p className="Helvetica Neue text-left text-[#888888] !text-xl mb-4 space-x-3 font-light">
                    “{t.text}”
                  </p>
                </div>
                <div className="flex items-center mt-4 relative z-10">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-[80px] h-[80px] rounded-full border-2 border-white shadow-md mr-4 transform transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="text-left">
                    <h4 className="text-gray-900 text-[20px] font-bold">{t.name}</h4>
                    <p className="text-sm text-[13px] font-light text-[#515151]">{t.role}</p>
                    <div className="flex mt-2">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <span key={i} className="text-orange-500 text-xl transition-transform duration-300 group-hover:scale-125">★</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-button-prev-testimonials md:hidden text-white bg-[#234042] rounded-full w-10 h-10 flex items-center justify-center absolute left-2 top-1/2 transform -translate-y-1/2 z-10">
            <ArrowRight className="w-6 h-6 rotate-180" />
          </div>
          <div className="swiper-button-next-testimonials md:hidden text-white bg-[#234042] rounded-full w-10 h-10 flex items-center justify-center absolute right-2 top-1/2 transform -translate-y-1/2 z-10">
            <ArrowRight className="w-6 h-6" />
          </div>
          <div className="swiper-pagination-testimonials mt-4"></div>
        </Swiper>
      </div>
    </section>

    {/* section 9  */}
    <section
      className="bg-white text-center lg:pb-[100px] sm:pt-[100px] pb-10 px-8 lg:px-0"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      {/* Aapka heading aur description */}
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-start md:items-center mb-8 space-y-4 md:space-y-0 md:space-x-20">
        <h2 className="Bebas-neue text-2xl md:text-[75px] font-bold text-[#234042] whitespace-nowrap uppercase">
          Blogs & NEWS
        </h2>
        <p className="text-[#234042] text-left text-[16px] flex-1 helvetica-neue">
          Explore insights, tips, and industry trends on how to get the most out of LiveQR.
          Whether you're a beginner or a pro, our blog is packed with valuable content to help
          you level up your QR code strategy.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4">
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{
            clickable: true,
            el: ".swiper-pagination-blogs",
            renderBullet: function (index, className) {
              return `<span class="${className} md:hidden"></span>`;
            },
          }}
          navigation={{
            nextEl: ".swiper-button-next-blogs",
            prevEl: ".swiper-button-prev-blogs",
            hiddenClass: "swiper-button-hidden",
            disabledClass: "swiper-button-disabled",
          }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: {
              slidesPerView: 3,
              navigation: {
                enabled: false,
              },
            },
          }}
          className="relative"
        >
          {blogData.map((blog, index) => (
            <SwiperSlide key={blog.id} className="flex justify-center">
              <Link to={`/blog/${blog.slug}`}>
                <div
                  className="overflow-hidden flex flex-col w-full max-w-sm h-[500px] bg-white shadow-md rounded-lg"
                  data-aos="zoom-in"
                  data-aos-delay={`${index * 100}`}
                >
                  <div className="flex-shrink-0 overflow-hidden group">
                    <LazyLoad height={320} offset={100} once>
                      <img
                        src={blog.picture}
                        alt={blog.title}
                        className="w-full h-80 object-cover transition-transform duration-1000 group-hover:scale-110"
                      />
                    </LazyLoad>
                  </div>
                  <div className="bg-[#234042] text-white text-left px-6 py-6 flex flex-col flex-grow">
                    <h4 className="text-lg font-medium oswald">{blog.title}</h4>
                    <div className="oswald mt-auto text-[14px] font-medium flex items-center gap-2 text-white opacity-80">
                      READ MORE <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
          <div className="swiper-button-prev-blogs lg:hidden text-[#234042] rounded-full w-10 h-10 flex items-center justify-center absolute left-2 top-1/2 transform -translate-y-1/2 z-10">
            <ArrowRight className="w-10 h-10 rotate-180" />
          </div>
          <div className="swiper-button-next-blogs lg:hidden text-[#234042] rounded-full w-10 h-10 flex items-center justify-center absolute right-2 top-1/2 transform -translate-y-1/2 z-10">
            <ArrowRight className="w-10 h-10" />
          </div>
          {/* Pagination bullets */}
          <div className="swiper-pagination-blogs mt-4"></div>
        </Swiper>
      </div>

      <div
        className="mt-12 text-left px-4 max-w-7xl mx-auto flex items-center lg:justify-center justify-center"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <Link to="/blog">
          <button className="bg-[#F47321] uppercase hover:bg-[#F47321] text-white rounded-none transition transform scale-y-125 text-xs lg:text-[18px] lg:px-4 lg:py-3 px-2 py-2 flex items-center gap-2 font-medium btn-hover-effect">
            <span>VIEW ALL BLOGS & NEWS</span>
            <span className="icon-arrow-right">
              <ArrowRight className="w-4 h-4" />
            </span>
          </button>
        </Link>
      </div>
    </section>

  </>);
}